import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { InfoProfile } from '../../shared/services/info-profile';
import { CoreStore } from '../state/core.store';
import { AuthSession } from './auth-session';

@Injectable({ providedIn: 'root' })
export class AuthBootstrap {
  private readonly _session = inject(AuthSession);
  private readonly _profileService = inject(InfoProfile);
  private readonly _coreStore = inject(CoreStore);

  restore(): Observable<void> {
    if (!this._session.isAuthenticated()) {
      return of(undefined);
    }

    return this._profileService.infoProfile().pipe(
      tap((profile) => this._coreStore.setProfile(profile)),
      map(() => undefined),
      catchError(() => {
        this._session.clear();
        return of(undefined);
      }),
    );
  }
}
